"use client";

import type { FC } from "react";
import { cn } from "../../lib/utils";
import { DragHandleIcon } from "../../vectors";
import { Button } from "../Button/Button";

export interface DragHandleProps {
  /** dnd-kit `attributes` spread onto the handle (typed as `object` so this stays dnd-agnostic). */
  attributes?: object;
  /** dnd-kit `listeners` spread onto the handle. */
  listeners?: object;
  /** Accessible label, e.g. `Drag "Step 1"`. */
  label: string;
  size?: "sm" | "md";
  className?: string;
}

/** Icon-only grab handle for dnd-kit sortable rows. Spreads the provided drag attributes/listeners. */
export const DragHandle: FC<DragHandleProps> = ({ attributes, listeners, label, size = "md", className }) => (
  <Button
    isIconOnly
    variant="light"
    size="sm"
    className={cn("cursor-grab touch-none active:cursor-grabbing", className)}
    aria-label={label}
    {...attributes}
    {...listeners}
  >
    <DragHandleIcon className={cn(size === "sm" ? "size-4" : "size-5", "text-icon-neutral-onMatch-usual")} />
  </Button>
);
